const $ = require("jquery");
require("slick-carousel");

/**
 * "See our clients in action" carousel for the shared vertical-lp clients block.
 * Markup: templates/public/static/components/partials/vertical-lp/clients-section.html.twig
 *
 * Require this from a page JS entry:
 *   require("../../components/ui-components/clientsCarousel");
 * It self-initialises on DOM ready and does nothing when the block is absent,
 * so it is safe to require from an entry shared by several pages.
 *
 * Desktop keeps the plain 3-up CSS grid: slick only takes over at tablet and
 * below, where the design scrolls the cards sideways with arrows, like the
 * reviews block. Slick is attached and detached on the breakpoint rather than
 * initialised everywhere, because once slick is on it writes inline widths onto
 * the list and its items, which would fight the grid.
 *
 * The prev/next labels are read from the markup so they stay translated.
 */
function initClientsCarousel() {
    const $cards = $(".vlp-clients__cards");
    if (!$cards.length) {
        return;
    }

    const $nav = $(".vlp-clients__nav");
    const prevLabel = $nav.data("prev-label") || "Previous";
    const nextLabel = $nav.data("next-label") || "Next";
    const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

    // $tab in assets/scss/base/vars.scss
    const mq = window.matchMedia("(max-width: 1023px)");

    function enable() {
        if ($cards.hasClass("slick-initialized")) {
            return;
        }

        $cards.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            speed: 300,
            dots: false,
            arrows: true,
            appendArrows: $nav.length ? $nav : $cards,
            prevArrow: '<button type="button" class="vlp-clients__arrow vlp-clients__arrow--prev" aria-label="' + prevLabel + '">' + arrowSvg + "</button>",
            nextArrow: '<button type="button" class="vlp-clients__arrow vlp-clients__arrow--next" aria-label="' + nextLabel + '">' + arrowSvg + "</button>",
            responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }]
        });
    }

    function disable() {
        if ($cards.hasClass("slick-initialized")) {
            $cards.slick("unslick");
        }
    }

    function sync() {
        if (mq.matches) {
            enable();
        } else {
            disable();
        }
    }

    sync();

    // addEventListener on MediaQueryList is not in older Safari; addListener is.
    if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", sync);
    } else if (typeof mq.addListener === "function") {
        mq.addListener(sync);
    }
}

$(function () {
    initClientsCarousel();
});

module.exports = { initClientsCarousel };
